import { fetchAllBannerGroups } from '@/services/bannerGroups'

/**
 * Mutation types of the store
 */
const mutationTypes = {
  FETCHING: 'FETCHING',
  FETCHED: 'FETCHED'
}

/**
 * Initial state
 */
const state = {
  loading: false,
  bannerGroups: undefined
}

/**
 * Getters
 */
const getters = {}

/**
 * Actions
 */
const actions = {
  fetchAllBannerGroups({ commit }) {
    commit(mutationTypes.FETCHING)

    return fetchAllBannerGroups()
      .then((bannerGroups) => {
        commit(mutationTypes.FETCHED, bannerGroups)
      })
      .catch((err) => {
        console.log(err)
        commit(mutationTypes.FETCHED)
      })
  }
}

/**
 * Mutations
 */
const mutations = {
  [mutationTypes.FETCHING](state) {
    state.loading = true
  },

  [mutationTypes.FETCHED](state, bannerGroups) {
    state.bannerGroups = bannerGroups
    state.loading = false
  }
}

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state
}
